<script>
  // A titled list of cards.
  //
  // Replaces the `card shadow-lg mt-5 {headerClass} w-4/6 mx-auto` wrapper,
  // where headerClass was bg-primary / bg-secondary / bg-error -- a full-bleed
  // saturated panel behind the whole list, at two-thirds width for no reason
  // the rest of the page shared. The heading survives; the paint does not.
  export let title;
  /** Row count shown next to the heading. null hides it. */
  export let count = null;
  export let noun = "job";
</script>

<section class="mt-6">
  <div class="mb-3 flex items-baseline justify-between gap-4 px-1">
    <h2 class="text-lg font-semibold">{title}</h2>
    {#if count !== null}
      <span class="text-sm tabular-nums opacity-50">
        {count}
        {count === 1 ? noun : noun + "s"}
      </span>
    {/if}
  </div>

  <div class="flex flex-col gap-3">
    <slot />
  </div>

  <slot name="footer" />
</section>
